export default {
    logging_in: 'Logging In',
    authentication_code_can_not_be_used: 'Authentication code has expired or has already been used for authentication. Please request a new code for login.',
    authentication_is_not_done: 'Authentication is not complete. Please use the provided link from the configuration menu requested from the used messenger.',
    logged_out: 'Logged Out',
    log_out: 'Log out',
    types: 'Types',
    project_types: 'Project types',
    tags_types: 'Tags',
    shift_types: 'Shift types',
    absences_types: 'Absences types',
    roles: 'Roles',
    employees: 'Employees',
    clients: 'Clients',
    tags: 'Tags',
    note: 'Note',
    value: 'Value',
    time_tracking_import_title: 'Import time tracking',
    time_tracking_import_mapped_target_will_be_created: '{target} "{name}" will be created',
    time_tracking_import_mapping_not_applied: 'Mapping to the existing {target} "{name}" was not applied: a new record would be created instead. Go back to data mapping and select the value again.',
    time_tracking_import_failed_default: 'Time tracking import failed. Check server response and try again.',
    time_tracking_import_blocked_no_file: 'Import is blocked: no file is selected',
    time_tracking_import_blocked_no_preview: 'Import is blocked: preview is not available',
    time_tracking_import_blocked_no_rows: 'Import is blocked: preview has no rows',
    time_tracking_import_blocked_diagnostics: 'Import is blocked: {errors} errors, {unresolved} unresolved values, {incomplete} incomplete mappings remain after Data Mapping',
    time_tracking_import_blocked_title: 'Import is blocked',
    time_tracking_import_skip_errors_title: 'Rows with errors',
    time_tracking_import_skip_errors_description: '{count, plural, one {# row has} other {# rows have}} errors and will not be imported unless skipped.',
    time_tracking_import_skip_errors_label: 'Skip rows with errors',
    time_tracking_import_unsupported_file: 'Only csv and xlsx files are supported',
    time_tracking_import_no_columns_detected: 'Columns were not detected. Ensure the first row of the file contains headers.',
    time_tracking_import_unable_to_read_file: 'Unable to read selected file',
    time_tracking_import_fill_required_mappings: 'Fill all required mappings before preview',
    time_tracking_import_imported_rows: 'Imported {count} rows',
    time_tracking_import_failed_with_counts: 'Import failed: {errors} errors, {unresolved} unresolved rows',
    time_tracking_import_failed_title: 'Import failed',
    time_tracking_import_return_to_timesheet: 'Return to timesheet',
    time_tracking_import_choose_file: 'Choose file',
    time_tracking_import_download_template: 'Download template',
    time_tracking_import_download_template_hint: 'Template for the current month: one row for every working day of your work calendar, with planned hours and the default shift type already filled in.',
    time_tracking_import_download_template_failed: 'Unable to download the import template',
    time_tracking_import_data_mapping: 'Data mapping',
    time_tracking_import_data_mapping_description: 'Map each unknown value once, or create it automatically during import.',
    time_tracking_import_continue: 'Continue',
    time_tracking_import_import_rows: 'Import rows',
    time_tracking_import_edit_mapping: 'Edit mapping',
    time_tracking_import_back: 'Back',
    time_tracking_import_data_mapping_rows_count: '{count, plural, one {# row} other {# rows}}',
    time_tracking_import_data_mapping_no_unresolved: 'No unresolved values were found. Continue to preview.',
    time_tracking_import_data_mapping_use_existing: 'Use existing',
    time_tracking_import_data_mapping_create_new: 'Create new',
    time_tracking_import_data_mapping_select_replacement: 'Select replacement',
    time_tracking_import_data_mapping_new_target_name: 'New {target} name',
    time_tracking_import_data_mapping_source_value_column: 'Source value',
    time_tracking_import_data_mapping_rows_column: 'Rows',
    time_tracking_import_data_mapping_action_column: 'Action',
    time_tracking_import_data_mapping_mapping_column: 'Mapping',
    time_tracking_import_data_mapping_source_variants: 'Values: {values}',
    time_tracking_import_preview_group_rows: '{count, plural, one {# row} other {# rows}}',
    time_tracking_import_preview_group_hours: '{count} h',
    time_tracking_import_preview_group_ready: '{count, plural, one {# ready} other {# ready}}',
    time_tracking_import_preview_group_warnings: '{count, plural, one {# warning} other {# warnings}}',
    time_tracking_import_preview_group_errors: '{count, plural, one {# error} other {# errors}}',
    time_tracking_import_preview_new_entity_tag: 'New',
    time_tracking_import_preview_status_ready: 'Ready',
    time_tracking_import_preview_status_warning: 'Warning',
    time_tracking_import_preview_status_error: 'Error',
    time_tracking_import_preview_no_issues: 'No issues',
    time_tracking_import_preview_column_status: 'Status',
    time_tracking_import_preview_column_date: 'Date',
    time_tracking_import_preview_column_hours: 'Hours',
    time_tracking_import_preview_column_project_absence: 'Project / Absence',
    time_tracking_import_preview_column_type: 'Type',
    time_tracking_import_preview_column_comment: 'Comment',
    time_tracking_import_preview_column_tags: 'Tags',
    time_tracking_import_preview_column_issues: 'Issues',
    time_tracking_import_preview_collapse_all: 'Collapse all',
    time_tracking_import_preview_expand_all: 'Expand all',
    time_tracking_import_preview_stat_total: 'Total',
    time_tracking_import_preview_stat_ready: 'Ready',
    time_tracking_import_preview_stat_warnings: 'Warnings',
    time_tracking_import_preview_stat_errors: 'Errors',
    time_tracking_import_preview_stat_unresolved: 'Unresolved',
    time_tracking_import_preview_title: 'Preview',
    time_tracking_import_preview_description: 'Review warnings and unresolved items before final import.',
    time_tracking_import_preview_unresolved_values: 'Unresolved values',
    time_tracking_import_preview_unresolved_rows: 'Rows: {rows}',
    time_tracking_import_manual_row_add: 'Add',
    time_tracking_import_manual_row_tag: 'Added manually',
    time_tracking_import_manual_row_edited_tag: 'Edited',
    time_tracking_import_preview_column_overtime: 'OV',
    time_tracking_import_removed_rows_notice: '{count, plural, one {# file row is removed from the import} other {# file rows are removed from the import}}',
    time_tracking_import_removed_rows_restore: 'Restore',
    time_tracking_import_manual_row_edit: 'Edit row',
    time_tracking_import_manual_row_remove: 'Remove row',
    time_tracking_import_manual_row_preview_failed: 'Unable to check the added row. Please try again.',
    time_tracking_import_manual_row_dialog_add_title: 'Add entry',
    time_tracking_import_manual_row_dialog_edit_title: 'Edit entry',
    time_tracking_import_manual_row_dialog_description: 'The entry is added to the preview and checked together with the file rows.',
    time_tracking_import_manual_row_employee_hint: 'Only employees from the imported file are available.',
    time_tracking_import_manual_row_date_out_of_range: 'Date is outside the allowed import period.',
    time_tracking_import_mapping_title: 'Map fields',
    time_tracking_import_mapping_description: 'Map required columns first. Optional fields may be left empty.',
    time_tracking_import_mapping_not_selected: 'Not selected',
    time_tracking_import_mapping_no_detected_columns: 'No detected columns',
    time_tracking_import_mapping_employee_column: 'Employee column',
    time_tracking_import_mapping_employee_column_description: 'Column with employee name, for example Expert.',
    time_tracking_import_mapping_employee_mode_column: 'Column',
    time_tracking_import_mapping_employee_mode_manual: 'Type name',
    time_tracking_import_mapping_employee_name_placeholder: 'Enter employee name',
    time_tracking_import_mapping_date_column: 'Date column',
    time_tracking_import_mapping_date_column_description: 'Column with work date.',
    time_tracking_import_mapping_hours_column: 'Hours column',
    time_tracking_import_mapping_hours_column_description: 'Column with tracked hours.',
    time_tracking_import_mapping_project_absence_column: 'Project / absence column',
    time_tracking_import_mapping_project_absence_column_description: 'Column with project name or absence type.',
    time_tracking_import_mapping_type_column: 'Type column',
    time_tracking_import_mapping_type_column_description: 'Optional shift or absence subtype.',
    time_tracking_import_mapping_comment_column: 'Comment column',
    time_tracking_import_mapping_comment_column_description: 'Optional note/comment column.',
    time_tracking_import_mapping_tags_column: 'Tags column',
    time_tracking_import_mapping_tags_column_description: 'Optional tags column (; , | separators are supported).',
    role_for_notification: 'Role for notification',
    project_manager: 'Project manager',
    projects: 'Projects',
    settings: 'Settings',
    preferences: 'Preferences',
    notifications: 'Notifications',
    integrations: 'Integrations',
    earlyAccess: 'Early Access',
    workCalendar: 'Work calendar',
    workspace: 'Workspace',
    billing: 'Billing',
    payments: 'Payment methods',
    currentPaymentMethod: 'Current Payment Method',
    paymentMethod_setup: 'Stripe is set',
    you_have_no_payment_method_added: 'You have not added a payment method',
    you_have_no_payment_method_added_desc: 'Add your debit or credit card to activate your subscription',
    add_payment_method: 'Add Payment Method',
    subscription: 'Subscription',
    timinator_trial: 'Trial Subscription',
    timinator_connected: 'Timinator Connected',
    timinator_free: 'Free plan',
    timinator_paid: 'Paid plan',
    timinator_full_potential: 'discover its full potential',
    your_sub_active_unt: 'Your subscription is active until {s}',
    per_human_per_month: 'For just {s} per human per month',
    try_timinator: 'Or try Timinator for free for 30 days',
    next_payment: 'Next Payment',
    get_list_of_features: 'Get the full list of features on',
    timinator_page: 'Timinator Page',
    profile: 'Profile',
    manage: 'Manage',
    admin: 'admin',
    email: 'Email',
    create_new: 'Create new',
    delete: 'Delete',
    name_placeholder: 'Name',
    write_something: 'Write something',
    me: 'Me',
    user: 'User',
    required: 'required',
    max_length_error: 'Must be 45 characters or less',
    phone_number_is_not_valid: 'Phone number is not valid',
    standard_work_day: 'standard work day',
    weekend_or_day_off: 'weekend or day off',
    customized: 'customized',
    choose_day_on_month_to_edit: 'Choose a day on month to edit:',
    empty_field_ability: 'You could use empty value for use global setting from workspace.',
    work_hours: 'Work hours',
    day_type: 'Day type',
    edit_date_settings: 'Edit date settings',
    calendar: 'Calendar',
    year: 'Year',
    work_calendar: 'Work calendar',
    create_work_calendar: 'Work calendar',
    edit_work_calendar: 'Work calendar',
    calendarName: 'Calendar name',
    region: 'Region',
    workHours_in_day: 'Work hours in a day',
    workHours_in_shortDay: 'Work hours in a short day',
    edit_work_calendar_info: 'If change this value then all custom dates will be reseted for it calendar.',
    edit_current_year: 'Edit current year',
    delete_work_calendar: 'Work calendar',
    delete_work_calendar_info: 'Are you sure that you want to delete "{s}" work calendar?',
    delete_work_calendar_root_warning: 'It is primary work calendar',
    integration_connect: 'Connect',
    integration_disconnect: 'Disconnect',
    integration_configure: 'Configure',
    integration_not_connected: 'Not connected',
    integration_none_available: 'There are no available integrations for your workspace.',
    integration_disconnect_title: 'Disconnect {s}',
    integration_disconnect_info: 'Disconnect integration',
    integration_disconnect_desc: 'Are you sure that you want to disconnect "{s}" integration?',
    integration_disconnect_done: 'Disconnected: {s} integration',
    integration_name: 'Integration {s}',
    zoho_integration_link: 'https://www.zoho.com',
    zoho_integration_desc: 'Read more about service',
    zoho_organizations: 'Organizations',
    zoho_employees_for_notify: 'Employees for notifications',
    select_one_more_projects: 'Select one or more projects',
    select_one_more_employees: 'Select one or more employees',
    integration_wating_for_configuration: 'Waiting for configuration',
    unknown_error: 'Unknown error.',
    we_re_working_on_it: 'We are already aware and working on it.',
    zoho_created_successfully: 'Your zoho account was added successfully.',
    zoho_request_not_found: 'We have not found the number of your request for add a zoho integration.',
    try_again: 'Try again or contact us',
    press_da_button_kronk: 'You could press the button below to back to the settings.',
    early_access_desc: 'You can get early access to new features and functions. But they may contain bugs or work incorrectly.\nBug fixes are distributed to everyone equally, regardless of early access.',
    time_z0: '+00:00 UTC Time Format',
    time_z1: '+01:00 (Dublin, London)',
    time_z2: '+02:00 (Amsterdam, Berlin, Oslo, Belgrade, Stockholm)',
    time_z3: '+03:00 (Moscow, Minsk, Kiev, Bucharest)',
    time_z4: '+04:00 (Dubai, Samara, Izhevsk)',
    time_z5: '+05:00 (Astana, Yekaterinburg, Dushanbe, Tashkent)',
    time_z6: '+06:00 (Chittagong, Bishkek, Omsk)',
    time_z7: '+07:00 (Bangkok, Hanoi, Krasnoyarsk)',
    time_z8: '+08:00 (Beijing, Ulan Bator, Singapore, Irkutsk)',
    time_z9: '+09:00 (Tokyo, Seoul, Chita)',
    time_z10: '+10:00 (Canberra, Vladivostok)',
    time_z11: '+11:00 (Kingston, Yuzhno-Sakhalinsk)',
    time_z12: '+12:00 (Wellington, Suva, Majuro)',
    time_z13: '+13:00 (Kiribati, Apia, Tokelau)',
    time_z14: '+14:00 (Tabwakea Village)',
    time_zw1: '-01:00 (Nuuk)',
    time_zw2: '-02:00 (Saint-Pierre)',
    time_zw3: '-03:00 (Bahia, Minas Gerais, New Brunswick)',
    time_zw4: '-04:00 (Quebec, Puente Alto, Florida, Michigan)',
    time_zw5: '-05:00 (Jamaica, Tennessee, Texas)',
    time_zw6: '-06:00 (Nunavut, Costa Rica, New Mexico)',
    time_zw7: '-07:00 (California, Yukon)',
    time_zw8: '-08:00 (Adamstown, Anchorage)',
    time_zw9: '-09:00 (Rikitea)',
    time_zw10: '-10:00 (Hawaii)',
    time_zw11: '-11:00 (Alofi, Pago Pago)',
    time_zw12: '-12:00 (Howland Island)',
    time_zone: 'Time zone',
    start_day_time: 'Start day time',
    end_day_time: 'End day time',
    hide_menu: 'Hide menu',
    item_of_item: '{f} of {s}',
    collapse: 'Collapse',
    collapse_all: 'Collapse all',
    shift: 'Shift',
    type: 'Type',
    status: 'Status',
    schedule: 'Time tracking',
    timesheet: 'Time sheet',
    timesheet_title: 'Time sheet:',
    timereport: 'Time report',
    timebankreport: 'Time bank report',
    timebankreport_manual_transaction: 'Time bank transaction',
    timebank_balance: 'Balance',
    timebank_added: 'Added',
    timebank_used: 'Used',
    timebank_opening_balance: 'Beginning balance',
    timebank_period_balance: 'Period balance',
    timebank_current_balance: 'Current balance',
    timebank_hours: 'Hours',
    timebank_source: 'Source',
    absence: 'Absence',
    schedule_timeshift_date: 'Date',
    schedule_timeshift_target: 'Project / Absence',
    schedule_timeshift_type: 'Type',
    schedule_timeshift_note: 'Comment',
    schedule_timeshift_internal_note: 'Internal note',
    schedule_timeshift_hours: 'Hours',
    schedule_timeshift_approve: 'Approve ({s})',
    schedule_timeshift_bill: 'Bill ({s})',
    schedule_timeshift_approve_all: 'Approve all ({s})',
    schedule_timeshift_approve_shift: 'Approve shift ({s})',
    schedule_timeshift_bill_all: 'Bill all ({s})',
    schedule_timeshift_bill_shift: 'Bill shift ({s})',
    schedule_timeshift_disapprove_all: 'Disapprove all ({s})',
    schedule_timeshift_disapprove_shift: 'Disapprove shift ({s})',
    schedule_timeshift_disapprove: 'Disapprove',
    schedule_timeshift_disapprove_format: 'Disapprove ({s})',
    schedule_timeshift_cancel_bill_all: 'Cancel billing ({s})',
    schedule_timeshift_cancel_bill: 'Cancel billing',
    schedule_total_hours: 'Total',
    schedule_regular_hours: 'Regular',
    schedule_approved_hours: 'Approved',
    schedule_billable_hours: 'Billable',
    schedule_is_overtime: 'Is overtime',
    schedule_add_to_time_bank: 'Put into time bank',
    schedule_use_from_time_bank: 'Take from time bank',
    schedule_overtime_hours: 'Overtime',
    schedule_planned_hours: 'Planned hours',
    schedule_worked_hours: 'Worked hours',
    schedule_absence_hours: 'Absence hours',
    schedule_time_bank_balance: 'Time bank balance',
    schedule_dayoff_hours: 'Day-off',
    schedule_employee_view: 'Employee View',
    schedule_project_view: 'Project View',
    schedule_filter_by_employees: 'Filter by Employees',
    schedule_filter_by_projects: 'Filter by Projects',
    schedule_filter_by_types: 'Filter by Types',
    schedule_create_report: 'Create report',
    schedule_creating_report: 'Creating...',
    schedule_create_timeshift_shift_to_this_day: 'Add shift to this day',
    schedule_create_timeshift_shift: 'Add shift',
    schedule_create_timeshift_absence: 'Add absence',
    schedule_edit_timeshift_shift: 'Edit shift',
    schedule_copy_timeshift_shift: 'Copy shift',
    schedule_copy_timeshift_absence: 'Copy absence',
    schedule_type_day: 'Day',
    schedule_type_week: 'Week',
    schedule_type_month: 'Month',
    schedule_nothing_to_approve: 'Nothing to approve',
    schedule_nothing_to_bill: 'Nothing to bill',
    shift_type: 'Shift type',
    tag_type: 'Tag',
    employee: 'Employee',
    project: 'Project',
    expand_all: 'Expand all',
    show_smth: 'Show {s}',
    hide_smth: 'Hide {s}',
    report: 'Report',
    create: 'Create',
    edit: 'Edit',
    currentMonth: 'Current month',
    nextMonth: 'Next month',
    thisWeek: 'This week',
    lastWeek: 'Last week',
    custom: 'Custom',
    previousMonth: 'Previous month',
    create_employee: 'Create employee',
    edit_employee: 'Edit employee',
    no_employees: 'You have no employees',
    create_and_use_employee: 'Create employee and add detailed info about it',
    employee_first_name: 'First name',
    employee_last_name: 'Last name',
    employee_position: 'Position',
    employee_admin: 'Admin',
    create_client: 'Create client',
    edit_client: 'Edit client',
    client_contact_person: 'Contact person',
    employee_main_information: 'Main information',
    employee_contact_information: 'Contact information',
    employee_assignments: 'Assignments',
    employee_will_work_balance: 'Time bank balance',
    client_site: 'Site',
    client_note: 'Note',
    no_clients: 'You have no clients',
    create_and_use_client: 'Create client and add detailed info about it',
    client_name_taken: 'Client name is taken',
    delete_client: 'Delete client',
    delete_client_message: 'Are you sure that you want to delete "{name}"?',
    phonenumber: 'Phone',
    form_name_required_format: '{s} name required',
    form_n_required_format: '{s} required',
    project_type: 'Project type',
    absence_type: 'Absence type',
    role: 'Role',
    client: 'Client',
    schedule_delete_timeshift_item: 'Delete item',
    schedule_delete_timeshift_shift: 'Delete shift',
    schedule_delete_timeshift_absence: 'Delete absence',
    schedule_edit_timeshift_absence: 'Edit absence',
    schedule_worked_hours_abbreviation: 'WH',
    schedule_planned_hours_abbreviation: 'PL',
    schedule_absence_hours_abbreviation: 'AH',
    schedule_overtime_hours_abbreviation: 'OV',
    schedule_time_bank_balance_abbreviation: 'TB',
    filter: 'Filter',
    reset_filter: 'Reset filter',
    Presets: 'Presets',
    apply_filter: 'Apply filter',
    clear_filters: 'Clear filters',
    clear: 'Clear field',
    favorite_filters: 'Favorite filters',
    save_as_favorite: 'Save current filter as favorite',
    favorite_name_placeholder: 'Favorite name',
    delete_favorite_confirm: 'Delete "{name}"?',
    no_favorite_filters: 'No saved filters yet',
    apply_and_go_back: 'Apply',
    favorite_filters_hint: 'Save the current filter or apply a previously saved one.',
    add_entities: 'Add {s}',
    show_absences: 'Show absences',
    report_all_days: 'All',
    report_only_incorrect_days: 'Show only incorrect days',
    start_typing: 'Start typing to add',
    vacation: 'Vacation',
    vacation_report: 'Vacation report',
    vacation_create_new_vacation: 'Request vacation',
    vacation_notify_about_start: 'Notify about start',
    vacation_notify_in_advance: 'Notify in advance',
    vacation_message: 'Message',
    from: 'From',
    to: 'To',
    choose_employee: 'Choose employee',
    vacation_state: 'State',
    vacation_state_wait_approve: 'Awaiting approval',
    vacation_state_approved: 'Approved',
    vacation_state_approved_by_you: 'Approved by you',
    vacation_notify_in_advance_disabled: 'Disabled',
    vacation_notify_in_advance_one_day: '1 day in advance',
    vacation_notify_in_advance_two_days: '2 days in advance',
    vacation_notify_in_advance_three_days: '3 days in advance',
    vacation_notify_in_advance_four_days: '4 days in advance',
    vacation_notify_in_advance_five_days: '5 days in advance',
    vacation_notify_about_start_teammates_only: 'Teammates only',
    vacation_notify_about_start_all_employees: 'All employees',
    vacation_invalid_employee_id: 'Invalid employee ID',
    vacation_invalid_date_from: 'Date From must be less than Date To', 
    vacation_invalid_date_to: 'Date To must be greater than Date From',
    vacation_approve_confirm_message: 'Are you sure you want to approve the vacation request?',
    vacation_approve_force_confirm_message: 'Approve the whole vacation request? Other approvers will no longer be required.',
    vacation_approve: 'Approve',
    vacation_ignore_other_approvers: 'Ignore other approvers',
    vacation_approver_approved: 'Approved',
    vacation_approver_not_approved: 'Not approved',
    vacation_cancel_confirm_message: 'Are you sure you want to cancel this vacation?',
    vacation_cancel_title: 'Cancel vacation',
    vacation_decline: 'Decline',
    vacation_decline_confirm_message: 'Are you sure you want to decline the vacation request?',
    vacation_decline_title: 'Decline vacation',
    vacation_approve_title: 'Approve vacation',
    previousQuarter: 'Previous quarter',
    currentQuarter: 'Current quarter',
    previousYear: 'Previous year',
    currentYear: 'Current year',
    cancel: 'Cancel',
    close: 'Close',
    default: 'Default',
    active: 'Active',
    suspended: 'Suspended',
    none: 'None',
    use_for_vacation: 'Use for vacation',
    use_for_will_work: 'Use for "Will work"',
    limit_to_planned_hours: 'Use planned hours only',
    save: 'Save',
    edit_project_type: 'Edit project type',
    create_project_type: 'Create project type',
    optional: 'optional',
    apply: 'Apply',
    all_statuses: 'All statuses',
    no_project_types: 'You have no project types',
    date: 'Date',
    cost: 'Cost',
    cost_add: 'Add cost',
    cost_delete: 'Delete cost',
    cost_edit: 'Edit cost',
    cost_files: 'Files',
    cost_amount: 'Amount',
    costreport: 'Cost report',
    delete_cost: 'Delete cost',
    delete_cost_info: 'Are you sure that you want to delete this cost?',
    cost_upload_files: 'Upload files',
    cost_note: 'Note',
    cost_upload_files_hint:'You can upload files with extension: pdf, png, jpg, xlsx. Maximum files count is 10.',
    cost_invalid_files_count: 'Invalid files count',
    cost_invalid_files_extension: 'Invalid files extension',
    create_and_use_project_type: 'Create project type and use it for projects',
    delete_project_type: 'Delete project type',
    delete_project_type_message: 'Are you sure that you want to delete "{name}" project type?',
    name: 'Name',
    no_absence_types: 'You have no absence types',
    create_and_use_absence_type: 'Create absence type and use it for shifts',
    delete_absence_type: 'Delete absence type',
    delete_absence_type_message: 'Are you sure that you want to delete "{name}" absence type?',
    edit_absence_type: 'Edit absence type',
    create_absence_type: 'Create absence type',
    no_shift_types: 'You have no shift types',
    create_and_use_shift_type: 'Create shift type and use it for shifts',
    delete_shift_type: 'Delete shift type',
    delete_shift_type_message: 'Are you sure that you want to delete "{name}" shift type?',
    edit_shift_type: 'Edit shift type',
    create_shift_type: 'Create shift type',
    create_tag_type: 'Create tag type',
    no_tag_types: 'You have no tag types',
    create_and_use_tag_type: 'Create tag type and use it for projects',
    delete_tag_type: 'Delete tag type',
    delete_tag_type_message: 'Are you sure that you want to delete "{name}" tag type?',
    edit_role: 'Edit role',
    create_role: 'Create role',
    no_roles: 'You have no roles',
    create_and_use_role: 'Create role and use it for employees',
    delete_role: 'Delete role',
    delete_role_message: 'Are you sure that you want to delete "{name}" role?',
    role_main_information: 'Main Information',
    role_permissions: 'Permissions',
    create_project: 'Create project',
    edit_project: 'Edit project',
    delete_project: 'Delete project',
    delete_project_message: 'Are you sure that you want to delete "{name}" project?',
    no_projects: 'You have no projects',
    create_and_use_project: 'Create project and add people to it',
    project_name_taken: 'Project name is taken',
    not_supported: 'Not supported yet',
    not_available: 'N/A',
    settings_early_access_title: 'Early Access',
    settings_early_access_active: 'Active',
    settings_early_access_not_enabled: 'Not enabled',
    settings_early_access_enable: 'Enable',
    settings_early_access_disable: 'Disable',
    settings_early_access_description_part1: 'You can get early access to new features and functions.',
    settings_early_access_description_part2: 'But they may contain bugs or work incorrectly.',
    settings_early_access_description_part3: 'Bug fixes are distributed to everyone equally, regardless of early access.',
    settings_notifications_channel_label: 'Channel for notifications',
    settings_notifications_month_end_toggle_label: 'Notifications at the end of the month',
    working_day: 'Working day',
    short_day: 'Short day',
    day_off: 'Day off',
    calendar_primary: 'Primary',
    dark_mode: 'Dark mode',
    light_mode: 'Light mode'
}
